import { baseUrl } from "../../../config/url-config/index";
import axiosInstance from "../axiosInstance";

const Delete = async (path, data) => {
  const result = await axiosInstance.delete(`${baseUrl}/${path}`);
  return result;
};

export default Delete;
